import { z } from 'zod'

/**
 *  testRide Detail Schema
 */
export const testRideDetailFormSchema = z.object({
  date: z.date({
    required_error: 'This is a required field.',
  }),
  time: z.string().trim().min(1, { message: 'This is a required field.' }),
})
